import Clipboard from 'bee-clipboard'

export default Clipboard
